// src/schedule/shift-type-help.js — what each shift type is FOR (v132.54).
//
// The ops manager, 25 Sep 2026: a store booked Authorised Paid Leave because a
// colleague's child was ill. Nobody misread a screen; the screen never said
// anything. "Auth. Paid Leave" reads like a fit for any authorised absence, and
// a manager had no way to learn otherwise inside the app.
//
// Matt's ruling, which these strings encode:
//   "If it is authorised = holiday. Not authorised = AWOL."
//   "If they have TOIL, use that first."
//   APL is for maternity, paternity, compassionate, or leave Head Office
//   approved outside holiday.
//
// ITS OWN MODULE for two reasons. src/schedule/index.js wraps its whole body in
// an IIFE, so nothing can be exported from inside it - and these strings are a
// policy statement to 104 people rather than modal plumbing, so they are worth
// a file somebody can find, review and change without reading rota code.
//
// ONE MAP, TWO SURFACES. This feeds BOTH the always-visible helper line under
// the buttons AND their hover text. Two copies would drift, and a tooltip that
// contradicts the line beneath it is worse than neither.
//
// ALWAYS VISIBLE, NOT HOVER-ONLY. The rota runs on store tills and on managers'
// phones, where hover does not exist - guidance only a desktop mouse can reach
// would miss most of the people making this mistake.
//
// Plain English on purpose: most managers reading this are not first-language
// English speakers. Keep the sentences short, and keep the rule in the words
// they already use.
//
// The keys are setShiftType's own type keys. A key with no button, or a button
// with no key, is a bug - tests/v132-54-shift-type-help_test.js pins both.
export const SHIFT_TYPE_HELP = {
  work:     'A normal working day at this store.',
  atstore:  'Working a shift at a different ELC store. Pick the store below.',
  off:      'A rostered day off. This is not holiday.',
  toil:     'Using time off they have already banked. If they have TOIL, use this before Holiday.',
  holiday:  'Any time off you have authorised, including an emergency day at short notice. If it is authorised, it is Holiday.',
  sick:     'Off sick.',
  apl:      'Maternity, paternity or compassionate leave, or leave approved by Head Office outside holiday. Not for ordinary time off: if you authorised it, use Holiday.',
  oos:      'On the rota but not at an ELC store, for example training or a meeting.',
};
